module.exports = "<ng-http-loader></ng-http-loader>\n<ig-layout></ig-layout>\n\n\n\n"